import React from "react";
import Icon from "../../Elements/Icon/Icon.tsx";
import Button from "../../Elements/Button/Button.js";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";
import LoaderContainer from "../LoaderContainer/LoaderContainer.js";
import useMailSender from "hooks/useMailSender.js";
import { useSaveAction } from "../../../hooks/useSaveAction.js";
import { useUser } from "../../../contexts/userContext/userContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";

const SaveMailButton = ({ showAsText }) => {
  const { isMailAvailable, getMailMetaData, getMailSecurity } = useMail();

  const { getTextByKey } = useContent();

  const { isLoggedIn, getUserData } = useUser();
  const { isMailSender } = useMailSender();

  const { handleClick, loading, isSavedByCurrentUser } = useSaveAction();

  const previewOnly = getMailSecurity()?.previewFiles && !isMailSender();

  const conditionToShow =
    isMailAvailable() &&
    (isLoggedIn() || !getMailMetaData().IsSaved) &&
    (!getMailMetaData().EmailOfEmbedOwner ||
      getMailMetaData().EmailOfEmbedOwner === getUserData().UserName) &&
    !getMailMetaData().IsManuallyDeleted &&
    !previewOnly;

  return (
    <>
      {conditionToShow ? (
        showAsText ? (
          <div className="save-mail-text" onClick={handleClick}>
            ({getTextByKey(`${isSavedByCurrentUser ? "un" : ""}save-mail-text`)}
            )
          </div>
        ) : (
          <Tooltip
            id={"saveActionIcon"}
            tooltipTextKey={`${
              isSavedByCurrentUser ? "un" : ""
            }save-icon-tooltip-text`}
            top
          >
            <LoaderContainer isLoading={loading}>
              <Button roundicon>
                <Icon
                  name={isSavedByCurrentUser ? "unsave-solid" : "save"}
                  xl
                  gray
                  clickable
                  onClick={handleClick}
                ></Icon>
              </Button>
            </LoaderContainer>
          </Tooltip>
        )
      ) : null}
    </>
  );
};

export default SaveMailButton;
